import {Navigation} from '@/components/Navigation'
import {Outlet, useLocation} from 'react-router'
import styled from 'styled-components'
import {Suspense} from 'react'
import {LoadingSpinner} from '@/components/loading/loading'
import {MAX_SCREEN_WIDTH} from '@/theme/theme'
import {spacing} from '@/theme/spacing'

const Page = styled.div`
    height: 100vh;
    overflow: auto;
    display: flex;
    flex-direction: column;
    background-color: ${(props) => props.theme.colors.background.page};
`

const PageContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 0 0;
    padding: ${spacing(1)};

    // This margin and width is here for legacy compatibility.
    // We limit all pages to this max width (for whatever the reason was) and we made
    // the page centers
    margin: auto;
    // If we want medulla to have more screen real estate, either disable this or change the limit
    max-width: ${MAX_SCREEN_WIDTH}px;
    width: 100%;
`

const LoadingContent = styled.div`
    width: 100%;
    height: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
`

function PageFallback() {
    return (
        <LoadingContent>
            <LoadingSpinner size={100} />
        </LoadingContent>
    )
}

export function NavigationBarLayout() {
    // https://github.com/remix-run/react-router/discussions/12773#discussioncomment-12856883
    const location = useLocation()
    return (
        <Page id="navigation-bar-layout">
            <Navigation />
            <Suspense key={location.pathname} fallback={<PageFallback />}>
                <PageContent id="navigation-bar-layout-page-content">
                    <Outlet />
                </PageContent>
            </Suspense>
        </Page>
    )
}
